/* sinjef-a11y.js — Mejoras de accesibilidad Horizon (07/09/2026, a11y audit axe)
 * 1) aria-hidden-focus: cualquier elemento [aria-hidden="true"] que contenga
 *    elementos enfocables NO debe poder recibir foco ni clic. Se sincroniza
 *    inert <=> aria-hidden: cuando la slide vuelve a aria-hidden="false"
 *    (o se le quita el atributo) se remueve inert automáticamente.
 * 2) button[role="listitem"]: rol no permitido en <button> (Horizon lo ponía en
 *    el disparador "más" del menú desktop) → se elimina.
 * No cambia layout/colores: solo estado de foco/accesibilidad.
 */
(function () {
  'use strict';

  function hasFocusables(el) {
    return !!el.querySelector('a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]');
  }

  function syncInert(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';
    var inerted = el.hasAttribute('inert');
    if (hidden && !inerted && hasFocusables(el)) {
      el.setAttribute('inert', '');
    } else if (!hidden && inerted) {
      el.removeAttribute('inert');
    }
  }

  function fixRoles() {
    document.querySelectorAll('button[role="listitem"]').forEach(function (b) {
      b.removeAttribute('role');
    });
    // Widget de WhatsApp (app Squadkin) queda fuera de landmarks → darle uno propio.
    document.querySelectorAll('whatsapp-chat-by-squadkin').forEach(function (w) {
      if (w.getAttribute('role') !== 'region') {
        w.setAttribute('role', 'region');
        w.setAttribute('aria-label', 'WhatsApp');
      }
    });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[aria-hidden]').forEach(syncInert);
    fixRoles();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || function (cb) { setTimeout(cb, 50); })(function () {
      scheduled = false;
      // barrido suave: sincronizar solo aria-hidden/inert global (barato si hay pocos)
      document.querySelectorAll('[aria-hidden]').forEach(syncInert);
      fixRoles();
    });
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (muts) {
      var touch = false;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (muts[i].type === 'attributes' && t.nodeType === 1) {
          if (t.hasAttribute('aria-hidden') || t.hasAttribute('inert')) syncInert(t);
          if (t.tagName === 'BUTTON' || t.tagName === 'A') touch = true;
        }
        if (muts[i].type === 'childList') touch = true;
      }
      if (touch) schedule();
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'inert', 'role', 'hidden']
    });
  }

  scan(document);
})();
